/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventLogMetadataExternalDto
 */
export interface EventLogMetadataExternalDto {
    /**
     * 
     * @type {Date}
     * @memberof EventLogMetadataExternalDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventLogMetadataExternalDto
     */
    activatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataExternalDto
     */
    type?: EventLogMetadataExternalDtoTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum EventLogMetadataExternalDtoTypeEnum {
    Investown = 'investown'
}

export function EventLogMetadataExternalDtoFromJSON(json: any): EventLogMetadataExternalDto {
    return EventLogMetadataExternalDtoFromJSONTyped(json, false);
}

export function EventLogMetadataExternalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventLogMetadataExternalDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'activatedAt': !exists(json, 'activatedAt') ? undefined : (new Date(json['activatedAt'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function EventLogMetadataExternalDtoToJSON(value?: EventLogMetadataExternalDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'activatedAt': value.activatedAt === undefined ? undefined : (value.activatedAt.toISOString()),
        'type': value.type,
    };
}

